<template>
  <div>
    <div class="box"></div>
    <sm-breadcrumb
      :data-list="[
        { name: '首页', path: 'home' },
        { name: '新闻动态', path: 'news-list' },
        { name: '新闻详情' },
      ]"
    />
    <div class="box2">
      <div class="left">
        <div class="title">最新资讯</div>
        <div
          :class="{ don: selectIndex === index }"
          v-for="(item, index) in newsList"
          v-if="index < 6"
          :key="index"
          class="new-title"
          @click="pageClick(index)"
        >
          <div>{{ item.titleSmall }}</div>
          <div>{{ item.year }}.{{ item.month }}.{{ item.day }}</div>
        </div>
      </div>
      <div class="right">
        <p class="tit">{{ newsList[selectIndex].titleSmall }}</p>
        <p class="dat">
          发布时间：{{ newsList[selectIndex].year }}.{{
            newsList[selectIndex].month
          }}.{{ newsList[selectIndex].day }}
        </p>
        <div
          class="content"
          v-for="(item, index) in newsList[selectIndex].content"
          :key="index"
        >
          <div
            v-if="newsList[selectIndex].content[index].type === 'image'"
            class="img"
          >
            <img :src="item.url" />
            <pre style="margin-top: 10px" v-if="item.imgTitle"
              >{{ item.imgTitle }}
            </pre>
          </div>
          <div
            v-if="newsList[selectIndex].content[index].type === 'text'"
            class="txt"
          >
            <pre
              display="overflow:auto"
              :style="{ 'font-weight': _index % 2 == 1 ? 'bold' : 'normal' }"
              v-for="(_item, _index) in item.content"
              :key="_index"
              >{{ _item }}</pre
            >
          </div>
          <div v-if="newsList[selectIndex].content[index].type === 'a'">
            <a
              :href="item.href"
              target="_blank"
              style="display: block; font-size: 0.2rem"
              >{{ item.content }}</a
            >
          </div>
          <div v-if="newsList[selectIndex].content[index].type === '12a'">
            <a
              :href="`https://www.fantacg.com/#/index/new?page=${
                newsList.length - 12
              }`"
              target="_blank"
              style="display: block; font-size: 0.2rem"
              >{{ item.content }}</a
            >
          </div>
          <div
            v-if="newsList[selectIndex].content[index].type === 'video'"
            class="video"
          >
            <div
              v-if="newsList[selectIndex].content[index].videoType === 'local'"
              class="video"
            >
              <video
                width="100%"
                height="100%"
                :src="item.url"
                controls
              ></video>
            </div>
            <div
              v-if="newsList[selectIndex].content[index].videoType === 'oss'"
              class="video"
            >
              <iframe
                :src="item.url"
                frameborder="0"
                width="100%"
                height="100%"
                scrolling="no"
                allowfullscreen
              ></iframe>
            </div>
          </div>
        </div>
        <div class="but">
          <span class="l" @click="upClick()">上一篇</span>
          <span class="r" @click="downClick()">下一篇</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      newsList: [],
      selectIndex: 0,
    }
  },
  created() {
    this.selectIndex = this.$route.query.page
  },
  mounted() {
    this.newsList = this.$newsList.concat()
    this.newsList.sort((a, b) => b.num - a.num)
  },
  methods: {
    pageClick: function (index) {
      this.selectIndex = index
      this.$router.push('new?page=' + this.selectIndex)
      document.documentElement.scrollTop = 0
    },
    upClick() {
      if (this.selectIndex > 0) {
        this.selectIndex = Number(this.selectIndex) - 1
        this.$router.push('new?page=' + this.selectIndex)
        document.documentElement.scrollTop = 0
      }
    },
    downClick() {
      if (this.selectIndex != this.newsList.length - 1) {
        this.selectIndex = Number(this.selectIndex) + 1
        this.$router.push('new?page=' + this.selectIndex)
        document.documentElement.scrollTop = 0
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.box {
  height: 2.9rem;
  width: 100%;
  background: url('../../assets/images/about/news/xw.jpg');
  background-size: 100% 100%;
}

.box2 {
  width: 12rem;
  margin: 0.6rem auto 0;
  display: flex;

  .left {
    width: 3rem;
    overflow: hidden;

    .title {
      font-size: 0.2rem;
      position: relative;
      padding-left: 0.1rem;
      margin-bottom: 0.19rem;
    }

    .title::before {
      position: absolute;
      content: '';
      left: 0;
      top: 0.06rem;
      background: #e70f20;
      width: 2px;
      height: 0.16rem;
    }

    .new-title {
      padding-bottom: 0.1rem;
      margin-bottom: 0.1rem;
      border-bottom: 1px solid #dcdcdc;

      > div {
        &:first-child {
          font-size: 0.14rem;
          line-height: 0.24rem;
          cursor: pointer;
          color: #686868;

          &:hover {
            color: #e70f20;
          }
        }

        &:last-child {
          font-size: 0.14rem;
          margin-top: 0.1rem;
          color: #989898;
        }
      }
    }

    .don {
      > div {
        &:first-child {
          color: #e70f20;
        }
      }
    }
  }

  .right {
    margin-left: 0.15rem;
    border-left: 1px solid #e5e5e5;
    width: 9rem;
    padding-left: 0.85rem;

    p.tit {
      width: 5.7rem;
      font-size: 0.26rem;
      text-align: center;
      margin: 0 auto;
      line-height: 0.41rem;
      letter-spacing: 1px;
      white-space: pre-wrap;
    }

    p.dat {
      text-align: center;
      letter-spacing: 1px;
      color: #3f3f3f;
      margin: 0.07rem 0;
    }

    div.img {
      text-align: center;
      margin: 0.07rem 0;

      img {
        width: 100%;
      }
    }

    div.txt {
      margin: 0.44rem 0;
      line-height: 0.36rem;
      color: #595757;
      font-size: 0.18rem;
      text-align: justify;
    }

    pre {
      white-space: pre-wrap;
    }

    div.video {
      margin: 0.4rem auto 0.2rem;
      width: 100%;
      height: 5rem;
    }

    div.but {
      text-align: center;
      margin-top: 0.56rem;

      span {
        width: 69px;
        height: 26px;
        line-height: 29px;
        display: inline-block;
        font-size: 12px;
        margin: 0 0.25rem;
        cursor: pointer;
      }

      .l {
        background: url('../../assets/images/pg.png');
        background-size: 100% 100%;
        padding-left: 0.07rem;
      }

      .r {
        background: url('../../assets/images/pg2.png');
        background-size: 100% 100%;
        padding-right: 0.07rem;
      }
    }
  }
}
</style>
